{
  "collapse": "Свиване",
  "expand": "Разширяване"
}
